import { Button, DatePicker, Form, Input, Select, message } from "antd";
import { useEffect, useState } from "react";
import { SiMicrosoftexcel } from "react-icons/si";
import { useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import * as XLSX from "xlsx";
import Loading from "../../components/loading";
import API from "../../config/api";
import { DELETE, GET, POST, PUT } from "../../utils/apiCalls";
import PageHeader from "../routes/pageHeader";
import DataTable from "./components/dataTable";
import "./styles.scss";
import dayjs from "dayjs";

function MeetingScreen() {
  const [form] = Form.useForm();
  const Events = useSelector((state: any) => state.Events);
  const user = useSelector((state: any) => state.User.user);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [meetingRooms, setMeetingRooms] = useState([]);
  const [isLoading, setIsLoading] = useState({
    data: true,
    startups: true,
    excel: false,
    meetingRooms: true,
  });

  const [startups, setStartups] = useState([]);
  const [data, setData] = useState([]);
  const [meta, setMeta] = useState<any>({});
  const [data1, setData1] = useState<any>(1);

  useEffect(() => {
    getData();
    loadStartups();
    loadMeetingRooms();
  }, [data1]);

  const getData = async () => {
    try {
      setIsLoading((prev) => ({ ...prev, data: true }));
      const params = {
        ...(searchParams.get("query") && { query: searchParams.get("query") }),
        ...(searchParams.get("startup_id") && {
          startup_id: searchParams.get("startup_id"),
        }),
        ...(searchParams.get("startDate") && {
          startDate: searchParams.get("startDate"),
        }),
        ...(searchParams.get("start") && { start: searchParams.get("start") }),
        ...(searchParams.get("pending") && {
          pending: searchParams.get("pending"),
        }),
        ...(searchParams.get("room_id") && {
          room_id: Number(searchParams.get("room_id")),
        }),
        ...(searchParams.get("page") && { page: searchParams.get("page") }),
        ...(searchParams.get("limit") && { take: searchParams.get("limit") }),
        ...(searchParams.get("sortBy") && { sortBy: searchParams.get("sortBy") }),
        ...(searchParams.get("sortOrder") && { sortOrder: searchParams.get("sortOrder") }),
        ...(searchParams.get("statusFilter") && { statusFilter: searchParams.get("statusFilter") }),
        ...(searchParams.get("pending") && { pending: searchParams.get("pending") }),
        ...(searchParams.get("start ") && { start : searchParams.get("start ") }),
        eventId: Events?.defult?.id,
      };
      const url = API.MEETINGS_LIST_SEARCH;
      const res: any = await GET(url, params);

      if (res.status) {
        setData(res.data);
        setMeta(res.meta);
      } else {
        message.error("Failed to fetch meetings data.");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      message.error("An error occurred while fetching meetings.");
    } finally {
      setIsLoading((prev) => ({ ...prev, data: false }));
      setLoading(false);
    }
  };

  const generateExcel = async () => {
    try {
      setIsLoading((prev) => ({ ...prev, excel: true }));
      const params = {
        ...(searchParams.get("query") && { query: searchParams.get("query") }),
        ...(searchParams.get("startup_id") && {
          startup_id: searchParams.get("startup_id"),
        }),
        ...(searchParams.get("startDate") && {
          startDate: searchParams.get("startDate"),
        }),
        ...(searchParams.get("start") && { start: searchParams.get("start") }),
        ...(searchParams.get("pending") && {
          pending: searchParams.get("pending"),
        }),
        ...(searchParams.get("room_id") && {
          room_id: Number(searchParams.get("room_id")),
        }),
        ...(searchParams.get("sortBy") && { sortBy: searchParams.get("sortBy") }),
        ...(searchParams.get("sortOrder") && { sortOrder: searchParams.get("sortOrder") }),
        ...(searchParams.get("start ") && { sortOrder: searchParams.get("start ") }),
        ...(searchParams.get("pending") && { sortOrder: searchParams.get("pending") }),
        ...(searchParams.get("statusFilter") && { statusFilter: searchParams.get("statusFilter") }),
        eventId: Events?.defult?.id,
      };
      const url = API.MEETINGS_LIST_SEARCH;
      const response: any = await GET(url, params);
     
      if (response?.status) {
        const arr = response.data.map((item: any, index: number) => {
          const createdAt = new Date(item.createdAt);
          const updatedAt = new Date(item.updatedAt);
          const date = createdAt.toLocaleDateString();
          const time = createdAt.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
           const updateddate = updatedAt.toLocaleDateString();
          const updatedtime = updatedAt.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
          
          return {
            "No.": index + 1,
            "Corporate Company": item?.investors?.company,
            "Corportae Name": item.investor_name,
            "Startup Name": item.startup_name,
            Room: item?.investors?.meeting_room,
            Slot: item.slot,
            "Created At": date + "" + time,
            "Updated At": updateddate + " " + updatedtime
          };
        });

        const worksheet = XLSX.utils.json_to_sheet(arr);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Meetings Report");

        const excelBuffer = XLSX.write(workbook, {
          bookType: "xlsx",
          type: "array",
        });
        const dataBlob = new Blob([excelBuffer], {
          type: "application/octet-stream",
        });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(dataBlob);
        link.download = `Meetings-Report-${new Date().toLocaleDateString()}.xlsx`;
        link.click();
      } else {
        message.error("Failed to generate the excel report.");
      }
    } catch (err) {
      console.error("Error generating excel:", err);
      message.error("An error occurred while generating the excel report.");
    } finally {
      setIsLoading((prev) => ({ ...prev, excel: false }));
    }
  };

  const loadStartups = async () => {
    try {
      const response: any = await GET(
        `${API.STARTUPS_PICKER}${Events?.defult?.id}`,
        null
      );
      if (response?.status) {
        setStartups(response.data);
      }
    } catch (err) {
      console.error("Error loading startups:", err);
    } finally {
      setIsLoading((prev) => ({ ...prev, startups: false }));
    }
  };
  
  const loadMeetingRooms = async () => {
    try {
      let obj = {
        eventId: Events?.defult?.id,
      };
      const response: any = await POST(API.ROOMS_LIST_ALL, obj);
      if (response?.status) {
        setMeetingRooms(response.data.map((item: any) => ({
          label: item.name,
          value: item.id,
        })));
      }
    } catch (err) {
      console.error("Error loading startups:", err);
    } finally {
      setIsLoading((prev) => ({ ...prev, meetingRooms: false }));
    }
  };

  const deleteItem = async (id: any) => {
    try {
      const response: any = await DELETE(`${API.MEETINGS_DELETE}${id}?updated_by=${user.name}`);
      if (response?.status) {
        message.success("Meeting deleted successfully.");
        getData();
      } else {
        message.error("Failed to delete the meeting.");
      }
    } catch (err) {
      console.error("Error deleting meeting:", err);
      message.error("An error occurred while deleting the meeting.");
    }
  };
  
  const updateStatus = async (id: any, userName: string) => {
    try {
      let obj = { id, userName }
      const response: any = await PUT(API.UPDATE_MEETING, obj)
      if (response?.status) {
        message.success("Meeting Cancelled Successfully.")
        getData();
      }
    } catch (error) {
      console.log("error")
    }
  }

  const changeParams = (data: any) => {
    const queryParams = [
      { key: "start", value: searchParams.get("start") },
      { key: "pending", value: searchParams.get("pending") },
      { key: "query", value: data?.query || (data?.val && searchParams.get("query")) },
      { key: "startup_id", value: data?.startup_id || (data?.val && searchParams.get("startup_id")) },
      { key: "startDate", value: data?.startDate || (data?.val && searchParams.get("startDate")) },
      { key: "room_id", value: data?.room_id || (data?.val && searchParams.get("room_id")) },
      { key: "statusFilter", value: data?.statusFilter || (data?.val && searchParams.get("statusFilter")) }, // 👈 new
      { key: "sortBy", value: data?.sortBy !== undefined ? data.sortBy : (data?.val && searchParams.get("sortBy")) },
      { key: "sortOrder", value: data?.sortOrder !== undefined ? data.sortOrder : (data?.val && searchParams.get("sortOrder")) },
    ]
      .filter((param) => param.value)
      .map((param) => `&${param.key}=${param.value}`)
      .join("");
  
    const baseUrl = `/company/meetings?page=${
      data?.page || searchParams.get("page") || 1
    }&limit=${data?.pageSize || searchParams.get("limit") || 10}`;
  
    navigate(`${baseUrl}${queryParams}`);
    setData1(data1 + 1);
  };
  

  // Handle sorting change
  const handleSortChange = (sortBy: string, sortOrder: string) => {
    const obj = {
      page: searchParams.get("page") || 1, // Maintain current page when sorting
      sortBy,
      sortOrder,
    };
    changeParams(obj);
  };

  return (
    <div>
      <PageHeader title="Meetings" loading={isLoading.data}>
              <Form
          form={form}
          onValuesChange={(changingItem, allData) => {
            const obj = {
              ...allData,
              page: 1,
              startDate: changingItem?.startDate
                ? dayjs(allData?.startDate).format("YYYY-MM-DD")
                : allData?.startDate,
            };
            changeParams(obj);
          }}
          initialValues={{
            query: searchParams.get("query"),
            startDate:
              searchParams.get("startDate") &&
              dayjs(searchParams.get("startDate")),
            startup_id: searchParams.get("startup_id"),
            room_id: searchParams.get("room_id"),
            statusFilter: searchParams.get("statusFilter") || null, // 👈 new filter
          }}
        >
          <div className="AdminHeader-extra">

        <Form.Item name="statusFilter" noStyle>
          <Select
            placeholder="Filter by Status"
            style={{ minWidth: 280 }}
            allowClear
            options={[
              { label: "Startups Currently Checked In", value: "su_checkin" },
              { label: "Startups Checked Out", value: "su_checkout" },
              { label: "Startups Never Checked In", value: "su_not_in" },
              { label: "Corporates Currently Checked In", value: "vc_checkin" },
              { label: "Corporates Checked Out", value: "vc_checkout" },
              { label: "Corporates Never Checked In", value: "vc_not_in" },
            ]}
          />
        </Form.Item>

            <Form.Item name="room_id" noStyle>
              <Select
                placeholder="Select Room"
                style={{ minWidth: 100 }}
                options={meetingRooms}
                optionFilterProp="label"
                allowClear
                showSearch
              />
            </Form.Item>

            <Form.Item name="query" noStyle>
              <Input style={{ width: 200 }} placeholder="Search" allowClear />
            </Form.Item>

            <Form.Item name="startDate" noStyle>
              <DatePicker placeholder="Date" style={{ minWidth: 100 }} />
            </Form.Item>

            {Array.isArray(user.access[Events?.defult?.id]) &&
            user.access[Events?.defult?.id].includes(8) ? null : (
              <Button
                loading={isLoading.excel}
                onClick={generateExcel}
                style={{ padding: 5, background: "#fff", cursor: "pointer" }}
              >
                EXPORT <SiMicrosoftexcel size={20} color="green" />
              </Button>
            )}
          </div>
        </Form>

      </PageHeader>
      {loading ? (
        <Loading />
      ) : (
        <DataTable
          data={data}
          meta={meta}
          loading={isLoading.data}
          delete={deleteItem}
          updateStatus={updateStatus}
          onPageChange={(page: number, pageSize: number) =>
            changeParams({ page, pageSize, val: true })
          }
          onSortChange={handleSortChange}
        />
      )}
    </div>
  );
}

export default MeetingScreen;